import { render, staticRenderFns } from "./IncFooterLanguages.vue?vue&type=template&id=56256528"
import script from "./IncFooterLanguages.vue?vue&type=script&lang=js"
export * from "./IncFooterLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports